// https://stackoverflow.com/questions/8188548/splitting-a-js-array-into-n-arrays

export default function splitTitlesArray(inputArray, words) {
  const headings = [];
  inputArray.forEach(sub => {
    const subheadings = [];
    if (sub.subheadings && sub.subheadings.length > 0) {
      sub.subheadings.forEach(subsub => {
        subheadings.push({ title: subsub.title });
      });
    }
    const newItem = {};
    newItem.title = sub.title;
    if (subheadings && subheadings.length > 0)
      newItem.subheadings = subheadings;
    headings.push(newItem);
  });
  const numSubArrays = words < 1000 ? 2 : 3;
  let result = [];
  for (let i = numSubArrays; i > 0; i--) {
    result.push(headings.splice(0, Math.ceil(headings.length / i)));
  }
  return result;
}
